// Description: JavaScript file for the FAQ page.

/**
 * @summary Sets up the FAQ functionality.
 * @deprecated function is no longer used. Replaced by HTML5 details and summary elements.
 */
const setupFaq = () => {
    const faqQuestions = document.querySelectorAll(".js-faq-question");

    faqQuestions.forEach(question => {
        question.addEventListener("click", () => {
            const parent = question.parentElement;
            const isOpen = parent.classList.contains("open");
            const openElements = document.querySelectorAll(".open");

            openElements.forEach(element => {
                if (element !== parent) {
                    element.classList.remove("open");
                    element.querySelector(".js-faq-answer").style.display = "none";
                }
            });

            if (!isOpen) {
                parent.classList.add("open");
                parent.querySelector(".js-faq-answer").style.display = "block";
            } else {
                parent.classList.remove("open");
                parent.querySelector(".js-faq-answer").style.display = "none";
            }
        });
    });
};
